import { CommonModule, Location } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ButtonComponent } from '../../component/button/button.component';

@Component({
  selector: 'eap-message-modal',
  templateUrl: './message-modal.component.html',
  styleUrls: ['./message-modal.component.scss'],
  imports :[CommonModule,ButtonComponent]
})
export class MessageModalComponent {
  constructor(
    private dialogRef: MatDialogRef<MessageModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { message: string; type: 'info' | 'error' },
    private location:Location
  ) {
    this.dialogRef.disableClose = true;
  }

  onClose(): void {
    this.dialogRef.close();
    if (this.data.message == "You are not authorized to access the Case") {
      this.location.back();
    }
  }
}
